import { Box, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IconTrash } from 'assets/img';
import { LwFormDate, LwFormInput, LwIconButton } from 'redesign';
import { AddClaFormValues } from './add-cla-dialog.types';

export type StepItemProps = {
  scaleIndex: number;
  stepIndex: number;
  onRemove: (stepIndex: number) => void;
};

export const StepItem = ({ scaleIndex, stepIndex, onRemove }: StepItemProps) => {
  const { t } = useTranslation('partner-screen-specific');
  const { control, watch } = useFormContext<AddClaFormValues>();

  const baseName = `scales.${scaleIndex}.steps.${stepIndex}` as const;
  const startDate = watch(`${baseName}.startDate`);

  return (
    <Row>
      <StepField>
        <LwFormInput
          name={`${baseName}.step`}
          control={control}
          label={t('partner-worker-detail.cla-form.step.label', { ns: 'partner-screen-specific' })}
          placeholder={t('partner-worker-detail.cla-form.step.placeholder', {
            ns: 'partner-screen-specific',
          })}
          rules={{
            required: t('partner-worker-detail.cla-form.step.required', {
              ns: 'partner-screen-specific',
            }),
          }}
        />
      </StepField>
      <DateField>
        <LwFormDate
          name={`${baseName}.startDate`}
          control={control}
          label={t('partner-worker-detail.cla-form.start-date.label', {
            ns: 'partner-screen-specific',
          })}
          rules={{
            required: t('partner-worker-detail.cla-form.start-date.required', {
              ns: 'partner-screen-specific',
            }),
          }}
        />
      </DateField>
      <DateField>
        <LwFormDate
          name={`${baseName}.endDate`}
          control={control}
          label={t('partner-worker-detail.cla-form.end-date.label', {
            ns: 'partner-screen-specific',
          })}
          minDate={startDate || undefined}
        />
      </DateField>
      <LwIconButton
        onClick={() => onRemove(stepIndex)}
        color="error"
        iconColorMode="stroke"
        size="medium"
        aria-label={t('partner-worker-detail.cla-form.step.remove.label', {
          ns: 'partner-screen-specific',
          number: stepIndex + 1,
        })}
      >
        <IconTrash width={18} height={18} />
      </LwIconButton>
    </Row>
  );
};

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  width: '100%',
}));

const StepField = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingBottom: theme.spacing(1),
}));

const DateField = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingBottom: theme.spacing(1),
}));
